import type { ChatMessage } from '@/app/KeywordTracker/types/aiModalTypes';
import { formatChatTimestamp } from './formatChatTimestamp';
import { successMessage, errorMessage } from '@/utils/toast';

export const exportMessagesToCsv = (
  messages: ChatMessage[],
  keyword?: string
) => {
  if (!messages || messages.length === 0) {
    errorMessage('هیچ پیامی برای خروجی وجود ندارد');
    return;
  }

  const csvHeader = 'Sender,Message,Time\n';
  const csvRows = messages
    .map(({ type, body, timestamp }) => {
      const senderName = type === 'user' ? 'شما' : 'AI';
      const messageText = (body?.message || '').replace(/"/g, '""');

      return `"${senderName}","${messageText}","${formatChatTimestamp(timestamp)}"`;
    })
    .join('\n');

  const blob = new Blob(['\uFEFF' + csvHeader + csvRows], {
    type: 'text/csv;charset=utf-8;'
  });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute(
    'download',
    `ai-analysis-${keyword || 'export'}-${new Date().getTime()}.csv`
  );
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  successMessage('فایل CSV با موفقیت دانلود شد');
};
